<template>
  <a-modal
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :footer="false"
    :width="368"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <h3 class="title">
      {{ title }}
    </h3>
    <div class="content">
      <a-select
        v-if="type === 'assign' && assignOptions"
        ref="assignSelect"
        :placeholder="selectPlaceholder"
        @change="handleChangeSelect"
      >
        <a-select-option
          v-for="item in assignOptions"
          :key="item.userid"
          :value="item.userid"
        >
          {{ item.truename }}
        </a-select-option>
      </a-select>
      <template v-else-if="type === 'receive'">
        <div>
          {{ $t('message["614"]') }}？
        </div>
      </template>
      <template v-else-if="type === 'allocate'">
        <a-checkbox
          v-if="enableshare"
          :checked="is_shared"
          @change="onChangeShare($event, $refs.allocateCascader)"
        >
          {{ $t('message["1725"]') }}
          <a-popover
            placement="right"
            :overlay-style="{ 'width': '200px' }"
          >
            <template slot="content">
              <p class="fs-gray">
                {{ $t('message["1726"]') }}
              </p>
            </template>
            <i class="iconfont iconicon-test34 fs-d6" />
          </a-popover>
        </a-checkbox>
        <my-cascader
          ref="allocateCascader"
          :data="newData"
          :get-data="getData"
          @change="handleChangeCascader"
        />
      </template>
      <template v-else-if="type === 'transfer'">
        <a-checkbox
          v-if="enableshare"
          :checked="is_shared"
          @change="onChangeShare($event, $refs.transferCascader)"
        >
          <!-- 小组共享 -->
          {{ $t('message["1725"]') }}
          <a-popover
            placement="right"
            :overlay-style="{ 'width': '200px' }"
          >
            <template slot="content">
              <p class="fs-gray">
                {{ $t('message["1726"]') }}
              </p>
            </template>
            <i class="iconfont iconicon-test34 fs-d6" />
          </a-popover>
        </a-checkbox>
        <my-cascader
          ref="transferCascader"
          :data="newData"
          :get-data="getData"
          @change="handleChangeCascader"
        />
      </template>
      <p class="error fs-red">
        {{ error }}
      </p>
    </div>
    <div class="footer">
      <a-button
        type="primary"
        @click="handleOk"
      >
        {{ $t('message["915"]') }}
      </a-button>
      <a-button
        type="default"
        @click="handleCancel"
      >
        {{ $t('message["896"]') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MyCascader from './../../formItem/Cascader'
import { getAuthTeamInfo, getTeamGroupDetail } from '@/services/index'
import { inquiryReceive, inquiryAssign, inquiryTransfer, inquiryAllocate } from '@/services/inqueryServices'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    MyCascader
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    },
    groupid: {
      type: [String, Number],
      default: () => { }
    },
    type: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      newData: this.data,
      confirmLoading: false,
      is_shared: false,
      assignOptions: [],
      error: ''
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    query () {
      return this.$route.query || {}
    },
    title () {
      let string = ''
      switch (this.type) {
        case 'transfer':
          string = this.$t('message["483"]') + '：'
          break
        case 'assign':
          string = this.$t('message["482"]') + '：'
          break
        case 'receive':
          string = this.$t('message["489"]')
          break
        case 'allocate':
          string = this.$t('message["481"]') + '：'
          break
      }
      return string
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
      this.newData = Object.assign({}, this.data)
    }
  },
  async created () {
    this.assignOptions = await this.getGroupDetail()
  },
  methods: {
    ...mapMutations('inquery/relateData', ['SET_RECYCLE_LOG_TIPS']),
    async getData (obj = {}) {
      // console.log(obj)
      let { type } = obj
      let params = { pk: 'inquiry-followup', type: 0 }
      if (type) { // 共享
        params.type = type
      }

      // 不选择共享；信息类型不是备案 // && !this.isBeiAn
      if (this.type === 'allocate' && !this.is_shared) {
        params.divide = 1 // 出现四列
      }

      // 分配或转移，并且非共享  && !this.is_shared
      if ((this.type === 'transfer' || this.type === 'allocate')) {
        params.deal = 1 // 去除空组和空团队
      }

      const result = await getAuthTeamInfo()
        .params({
          ...params
        }
        ).fetch()

      const { payload: data = [] } = (result && result.data) || {}
      /* if (this.type === 'transfer') {
        if (!this.is_shared) {
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)
        }
      } else if (this.type === 'allocate') {
        if (!this.is_shared) {
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)

          this.setFollowData(data)
        }
      } */

      if (this.type === 'allocate' && !this.is_shared) {
        this.setFollowData(data)
      }

      return data
    },
    /**
     * 当分配方式是1，选到人; 不是1，删除掉人的 children 数据
     */
    setFollowData (data) {
      for (let item of data) {
        if (item.hasOwnProperty('divide_type') && item.divide_type.length === 1 && item.divide_type[0] !== 1) {
          item.children = []
        }
        if (item.children && item.children.length) {
          this.setFollowData(item.children)
        }
      }
    },
    /* setGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        console.log(item.name)
        if (item.keyname === 'groupid' && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setGroupEmpty(item.children)
        }
      }
    }, */
    /* setRoleEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'roleid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
      }
    }, */
    async getGroupDetail () {
      if (!this.groupid) return

      const result = await getTeamGroupDetail()
        .params({
          groupid: this.groupid
        }).fetch()
      // console.log(result)
      const { payload = {} } = (result && result.data) || {}
      const { member = {} } = payload
      const { list = [] } = member
      return list
    },
    async onChangeShare (e, refCascader) {
      this.is_shared = e.target.checked
      if (refCascader) {
        refCascader.clearCascader()

        let type = this.is_shared ? 1 : 0

        let data = await this.getData({ type })
        refCascader.updateFollowOptions(data, this.is_shared)
      }
    },
    handleChangeCascader (value) {
      this.newData = value
    },
    handleChangeSelect (val) {
      this.newData.info.userid = val
    },
    hide () {
      this.$emit('update:visible', false)
      this.error = ''
    },
    async handleOk () {
      const { type, inquiryId: inquiryid, newData = {} } = this
      const { info = {} } = newData
      const { roleid = 0, groupid = 0, userid = 0, divide_type: divideType } = info
      let chain
      let params = {
        inquiryid
      }
      if (type === 'receive') { // 领取
        chain = await inquiryReceive()
      } else if (type === 'assign') { // 指派
        if (userid === 0) {
          this.error = this.$t('message["855"]')
          return
        }
        chain = await inquiryAssign()
      } else if (type === 'transfer') { // 转移
        if (roleid === 0 && groupid === 0 && userid === 0) {
          this.error = this.$t('message["855"]')
          return
        }
        chain = await inquiryTransfer()
        params.isshared = this.is_shared ? 1 : 0
      } else if (type === 'allocate') { // 分配
        if (roleid === 0 && groupid === 0 && userid === 0) {
          this.error = this.$t('message["855"]')
          return
        }
        if (divideType) {
          params.divide_type = divideType
        }
        chain = await inquiryAllocate()
        params.is_shared = this.is_shared
      }

      params.roleid = roleid
      params.groupid = groupid
      params.userid = userid

      this.error = ''

      chain
        .onNetSuccess(raw => {
          this.hide()
        })
        .onSuccess(payload => {
          const { from, type: typeNew } = this.$route.query
          if (type === 'transfer') {
            if (from && typeNew) {
              this.$router.push({
                name: 'InqueryList',
                query: {
                  ...this.query
                }
              })
            } else if (from === 'notice') {
              this.$router.push({ name: 'recordNotice' })
            } else if (from === 'webhook') {
              this.$router.push({
                name: 'configSendRecord',
                params: {
                  hookid: this.$route.query.hookid
                }
              })
            } else if (from === 'clue') {
              this.$router.push({
                name: 'InqueryClue'
              })
            } else if (from === 'ocpc') {
              this.$router.push({
                name: 'ocpc'
              })
            } else {
              this.$router.go(-1)
            }
          } else {
            eventBus.$emit('fetchInquiryDetail')
          }
          this.SET_RECYCLE_LOG_TIPS('')
        })
        .params(params)
        .fetch()
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
h3.title {
  font-weight: bold;
}
.content {
  padding: 8px 0 24px;
  .cascader {
    margin-bottom: 0;
  }
}
</style>
